module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"loadingIndicator":"Laster...","playGame":"Play Game","challengeFriends":"Challenge Friends"},"en":{"loadingIndicator":"Loading...","playGame":"Play Game","challengeFriends":"Challenge Friends"}}')
  delete Component.options._Ctor
}
